<template>
    <div>
        <div class="text-h6 font-weight-bold my-2 text-darkblue">Les listes de contacts</div>
        <div v-if="lists.length > 0" class="mb-2">Nombre de listes de contacts trouvées : {{ lists.length }}</div>
        <div v-if="lists.length == 0">Aucune liste de contacts trouvée</div>
        <v-row v-else>
            <v-col v-for="list in lists" :key="list.id" cols="12" sm="6" md="6" lg="4">
                <div class="spo-card rounded bordered pa-2">
                    <div class="text-h6 font-weight-bold  text-darkblue">{{ list.name }}</div>
                    <div class="text-body-1 font-weight-bold">{{ list.contacts_count }} contacts</div>
                    <div class="text-body-1">Crée le {{ $moment(list.created_at).format('DD/MM/YYYY HH:mm') }}</div>
                </div>

            </v-col>
        </v-row>
    </div>
</template>

<script>
import { useMailingSystemStore } from "@/stores/mailingSystem/mailingSystemStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";
import { useMainStore } from "@/stores/mainStore";
export default {
    computed: {
        ...mapStores(useMailingSystemStore),
        ...mapStores(useMainStore),
    },
    data() {
        return {
            lists: []
        }
    },
    async mounted() {
        let request = await AdminService.fetchAllContactsLists(this.mainStore.module.id);
        if (request) {
            this.lists = request;
        }


    }

}
</script>

<style lang="scss" scoped></style>